// Matches types in tempo-api
export enum JsxElementType {
  Component = "component",
  ComponentInstance = "component-instance",
  Element = "element",
  StorybookComponent = "storybook-component",
  Native = "native",
  LibraryComponent = "library-component",
}

export interface PropLocation {
  // If set to true, this prop references another part of the codebase, attempt to jump to it
  shouldAttemptJump?: boolean;
  start?: number;
  end?: number;
  value?: string | number | boolean;
}

export enum ImportType {
  ImportDefaultSpecifier = "ImportDefaultSpecifier",
  ImportSpecifier = "ImportSpecifier",
  ImportNamespaceSpecifier = "ImportNamespaceSpecifier",
}

/**
 * Defines a component that is imported to create a story
 */

export interface Import {
  name: string;
  filename: string;
  importedName?: string; // The original name that was imported (A in "import {A as B}")

  // ImportDefaultSpecifier => import X from "filename"
  // ImportSpecifier => import { X } from "filename"
  // ImportNamespaceSpecifier => import * as X from "filename";
  importType?: ImportType;
}

export interface JsxElement {
  key: string;
  type: JsxElementType;
  codebaseId: string;
  filename: string;

  componentName?: string;

  start?: number;
  startLine?: number;
  end?: number;
  closingTagEnd?: number;
  contentsStart?: number;
  contentsEnd?: number;
  inlineStyles?: { [key: string]: string };
  jsxName?: string;

  // For element only
  removableClasses?: string[];
  componentCodebaseId?: string;
  mostLikelyMatchingCssFile?: string;

  setProps?: {
    [propName: string]: {
      start: number | null;
      end: number | null;
      value: string | number | boolean | null;
    };
  };

  hasJsxContents?: boolean;
  staticTextContents?: boolean;

  // For component-instance only
  parentComponentCodebaseId?: string;
  parentComponentName?: string;
  componentSourceImport?: Import;

  // For library-component only
  libraryImport?: Import;

  // For storybook only
  importsForStory?: Import[];
  storybookSourceStart?: number;
  storybookSoureEnd?: number;
  storybookDefinitionType?: "component" | "object";
  library?: string;
  storybookMainComponentImport?: Import; // The import that is most likely pointing to the component this story is for

  // For storybooks defined by "object" only
  hasArgsKey?: boolean;
  isTemplateStory?: boolean;

  // For screenshot generation
  fileHash?: string;

  // For components only
  defaultExport?: boolean;
  props?: Record<string, unknown>;

  // For testing only
  tempoTestId?: string;
}
